import { PackagingType } from 'generated/graphql'
import { PackagingTypeSizePair } from 'types'

export const PackagingSizes: PackagingTypeSizePair = {
  PALLETSUKSTANDARD: {
    width: 100,
    length: 120,
  },
  PALLETSEURO: {
    width: 80,
    length: 120,
  },
}

export const PackageTypes: Record<PackagingType, string> = {
  BAGS: 'Bags',
  BALES: 'Bales',
  BLANKETS: 'Blankets',
  CONTAINERS: 'Containers',
  CRATES: 'Crates',
  PACKAGES: 'Packages',
  PALLETSEURO: 'Pallets Euro',
  PALLETSUKSTANDARD: 'Pallets UK Standard',
  STILLAGES: 'Stillages',
  ULD: 'ULD',
}